import { roleTypes } from '@digitale-verhuurders-verklaring/core/src/models/functions/authentication/types';
import { RouteLocationNormalized } from 'vue-router';

import { authUserHasAnyRole } from '../utils/auth';

export const handleRoles = async (
  to: RouteLocationNormalized,
): Promise<boolean> => {
  const roles = await roleTypes.array().safeParseAsync(to.meta.roles);

  if (!roles.success) {
    return false;
  }

  if (!(await authUserHasAnyRole(roles.data))) {
    return false;
  }

  return true;
};
